const ResultSectionType = {
  CATEGORY: 'category',
  PRODUCT: 'product',
  LINK: 'link',
}

export default ResultSectionType
